import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCustomizationsSetting, fetchOfaSetting, fetchTenantSetting } from './appInfoApi';
//import CallServer from '../../api/CallServer';
import { GetFromLocalStorage, SaveToLocalStorage } from '../../utils/utils';
import { BASE_URL, API_URL, TENANT, SAML_LOGIN_TENANT } from '../../config/constants';
import BRAND from '../../brand/config';

const initialState = {
  base_url: BASE_URL,
  api_url: API_URL,
  error: null,
  is_ofa: false,
  is_linked_to_app: true,
  is_self_assessment: false,
  // SAML-first tenants show the SAML login before the tenant settings arrive, so the login never switches under the user
  is_saml_login_enabled: SAML_LOGIN_TENANT.includes(TENANT),
  // set when a SAML-first tenant turns out to have SAML disabled: the login falls back to the e-mail with a warning
  saml_unavailable: false,
  personalizations: {
    ...(GetFromLocalStorage(`customization_settings_${TENANT}`) || {
      enabled_sections: {
        trainings:true,
        exams:true,
        notifications:false
      }
    }),
    ...BRAND.theme
  }
};

export const loadAppCustomizationsData = createAsyncThunk(
  'appInfo/loadStaticData',
  async () => {
    const response_tenant = await fetchTenantSetting();
    const response_customization = await fetchCustomizationsSetting();
    const response_ofa = await fetchOfaSetting();
    if (response_customization?.success) { 
      let settings = {
        ...response_customization?.data,
        ...(response_ofa?.success && {ofa_settings: response_ofa?.data || null}),
        ...(response_tenant?.success && {tenant_settings: response_tenant?.data || null})
      }
      SaveToLocalStorage(`customization_settings_${TENANT}`,settings);
      return settings
    } else {
      return response_customization
    }
  }
);

export const appInfoSlice = createSlice({
  name: "appInfo",
  initialState,
  reducers: {
    setInfoData: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.personalizations = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadAppCustomizationsData.fulfilled, (state, action) => {
        if(!action?.payload?.error){
          state.personalizations = {...action?.payload, ...BRAND.theme};
          state.is_linked_to_app = action?.payload?.tenant_settings?.is_linked_with_thefaculty || false;
          state.is_self_assessment = action?.payload?.tenant_settings?.is_self_assessment || false;
          state.is_ofa = action?.payload?.tenant_settings?.is_ofa || false;
          // ponytail: REACT_APP_FORCE_SAML_LOGIN is a temporary test override, drop it once the tenant flag is set
          state.is_saml_login_enabled = process.env.REACT_APP_FORCE_SAML_LOGIN === 'true' || action?.payload?.tenant_settings?.is_saml_login_enabled || false;
          state.saml_unavailable = SAML_LOGIN_TENANT.includes(TENANT) && !state.is_saml_login_enabled;
        } else {
          state.error = action?.payload?.error;
        }  
          
      });
  },
});
export default appInfoSlice.reducer;

export const selectAppInfo = (state) => state.appInfo;
export const selectBaseUrl = (state) => state.appInfo.base_url;
export const selectApiUrl = (state) => state.appInfo.api_url;
export const selectAppPersonalizations = (state) => state.appInfo.personalizations;